var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{staticClass:"pr-12 pr-sm-4 pl-sm-4 pl-10 mt-2 mb-14 d-flex justify-center",attrs:{"wrap":""}},[_c('v-flex',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }